import "../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { createInjectionKey as s } from "../_utils/vue/create-injection-key.js";
import { inject as c, provide as g, computed as r, onBeforeUnmount as F } from "../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const f = s("n-form-item");
function C(t, {
  defaultSize: m = "medium",
  mergedSize: o,
  mergedDisabled: i
} = {}) {
  const e = c(f, null);
  g(f, null);
  const a = r(o ? () => o(e) : () => {
    const {
      size: n
    } = t;
    if (n)
      return n;
    if (e) {
      const {
        mergedSize: u
      } = e;
      if (u.value !== void 0)
        return u.value;
    }
    return m;
  }), d = r(i ? () => i(e) : () => {
    const {
      disabled: n
    } = t;
    return n !== void 0 ? n : e ? e.disabled.value : !1;
  }), l = r(() => {
    const {
      status: n
    } = t;
    return n || (e == null ? void 0 : e.mergedValidationStatus.value);
  });
  return F(() => {
    e && e.restoreValidation();
  }), {
    mergedSizeRef: a,
    mergedDisabledRef: d,
    mergedStatusRef: l,
    nTriggerFormBlur() {
      e && e.handleContentBlur();
    },
    nTriggerFormChange() {
      e && e.handleContentChange();
    },
    nTriggerFormFocus() {
      e && e.handleContentFocus();
    },
    nTriggerFormInput() {
      e && e.handleContentInput();
    }
  };
}
export {
  C as default,
  f as formItemInjectionKey
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_mixins/use-form-item.js
// module id = 85
// module chunks = 67